import { callFunction } from '../utils/apiClient';

// --- Email NOTIFICATION preferences (weekly summaries etc.) — subscribed by default ---
export type EmailType = 'weekly_summary' | 'comeback' | 'product';
export interface EmailPrefs { subscribed: boolean; types: Record<EmailType, boolean> }
/** The signed-in user's email-notification preferences (master switch + per-category). */
export const getEmailPreferences = () => callFunction<EmailPrefs>('getEmailPreferences', {});
/** Subscribe / unsubscribe the signed-in user from ALL notification emails (master switch). */
export const setEmailPreferences = (subscribed: boolean) => callFunction<EmailPrefs>('setEmailPreferences', { subscribed });
/** Toggle one email category (weekly summary / comeback / product) without touching the master switch. */
export const setEmailTypePreference = (type: EmailType, on: boolean) => callFunction<EmailPrefs>('setEmailTypePreference', { type, on });
/** Public one-click unsubscribe from an email link (verifies the signed token; no login needed). */
export const emailUnsubscribe = (u: string, t: string) =>
  callFunction<{ unsubscribed: boolean }>('emailUnsubscribe', { u, t }, { requireAuth: false });
